export default "__VITE_ASSET__quoer884__"